//Dbg upl log level constants for paymentProfileModal
export const DbgUplLogLevel = {
  VERBOSE: 2, //DEFAULT
  DEBUG: 3,
  INFO: 4,
  WARN: 5,
  ERROR: 6,
};

//Dbg upl scheme constants for paymentProfileModal
export const DbgUplScheme = {
  NONE: "", //DEFAULT
  DAILY: "Daily",
  HOURLY: "Hourly",
  EVERY_COMMUNICATION: "EveryCommunication",
};

//Show dual price constants for paymentProfileModal
export const ShowDualPrice = {
  DO_NOT_SHOW: "dont_show",
  WHEN_DIFFERENT: "when_different",
  ALWAYS: "always",
};

//Enable transaction print constants from paymentProfileModal
export const receiptPrintMode = {
  ALWAYS: "Always",
  ASK: "Ask",
  NEVER: "Never",
}

//Signature settings constants for paymentProfileModal
export const SignatureSettings = {
  NEVER_ASK: "never_ask",
  ALWAYS_ASK: "always_ask",
  WHEN_TRANSACTIONS_EXCEED: "when_transactions_exceed",
};

export const TRANSACTION_EXCEED_AMOUNT = {
  DEFAULT: 25,
  MIN: 5
}

export const TenantTypes = {
  STANDARD: "STANDARD",
  GC_MARKET: "GC_MARKET",
  PATRON_GIVE: "PatronGive",
  LINK_PAY: "LinkPay"
}

export const ConfigType = {
  SHOPPING_CART: "ShoppingCart",
  QUICK_PAY: "QuickPay",
  LINK_PAY: "LinkPay",
  GC_MARKET_KIOSK: "GCMarketKiosk",
  GC_MARKET_SCANNER: "GCMarketScanner",
  GC_MARKET_ITEMS: "GCMarketItems"
}
